import { ComboBoxSelectedItem } from '../types/comboBoxSelectedItem'
import { ComboBoxValue } from '../types/comboBoxValue'

export const getSelectedValuesFromSelectedItems = (selectedItems: ComboBoxSelectedItem[]): ComboBoxValue[] =>
  selectedItems.map((item) => item.value.value)
